'use strict'

export const ExampleDirective = {
	bind (el) {
		el.style.color = 'red'
	}
}
